module.exports = __webpack_public_path__ + "img/qhjbh_cover.4e0cca64.png";